import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsVoteObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The changelog entry object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the entry.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description: 'Time at which the entry was first created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'The list of labels that the entry is associated with.',
                heading: 'labels',
                subheading: 'array',
              },
              {
                description: 'Time at which the entry was last updated, in ISO 8601 format.',
                heading: 'lastSaved',
                subheading: 'string',
              },
              {
                description: 'The markdown contents of the entry.',
                heading: 'markdownDetails',
                subheading: 'string',
              },
              {
                description:
                  'The plaintext contents of the entry, with images, videos, and links stripped.',
                heading: 'plaintextDetails',
                subheading: 'string',
              },
              {
                description: 'The list of posts this entry is linked to.',
                heading: 'posts',
                subheading: 'array',
              },
              {
                description: 'Time at which the entry was published, if it has been published.',
                heading: 'publishedAt',
                subheading: 'string',
              },
              {
                description:
                  'Time at which the entry is schedule to be published, if it is scheduled.',
                heading: 'scheduledFor',
                subheading: 'string',
              },
              {
                description: 'The number of reactions an entry has received.',
                heading: 'reactions',
                subheading: 'object',
              },
              {
                description:
                  'The status of the entry, describing whether it has been published. Will be set to draft, scheduled, or published.',
                heading: 'status',
                subheading: 'string',
              },
              {
                description: 'The title of the entry.',
                heading: 'title',
                subheading: 'string',
              },
              {
                description:
                  'The list of types associated with the entry. Can include new, improved, or fixed.',
                heading: 'types',
                subheading: 'array',
              },
              {
                description: 'The public URL to the entry page on Canny.',
                heading: 'url',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example entry object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba123b",
  "created": "${this.createdAt.toISOString()}",
  "labels": [],
  "lastSaved": "${this.createdAt.toISOString()}",
  "markdownDetails": "# heading\\n**bold**\\n[link](https://canny.io)",
  "plaintextDetails": "heading\\nbold\\nlink",
  "posts": [{
    "category": {
      "id": "553c3ef8b8cdcd1501ba2234",
      "name": "Dashboard",
      "postCount": 42,
      "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
    },
    "commentCount": 2,
    "eta": "February ${new Date().getFullYear()}",
    "id": "553c3ef8b8cdcd1501ba4444",
    "imageURLs": [],
    "jira": {
      "linkedIssues": [{
        "id": "123",
        "key": "ID-123",
        "url": "https://your-company.atlassian.net/browse/ID-123"
      }]
    },
    "linear": {
      "linkedIssueIDs": ["ID-123", "ID-345"],
    },
    "score": 13,
    "status": "planned",
    "tags": [{
      "id": "553c3ef8b8cdcd1501ba3234",
      "name": "iOS",
      "postCount": 15,
      "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
    }],
    "title": "post-title",
    "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
  }],
  "publishedAt": "${this.createdAt.toISOString()}",
  "reactions": {
    "like": 2
  },
  "scheduledFor": null,
  "status": "published",
  "title": "Entry title",
  "types": ["new", "improved"],
  "url": "https://your-company.canny.io/changelog/entry-title"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
